module.exports = __webpack_public_path__ + "img/our-expertise.c4eedb9b.jpg";